import React from 'react';
import PropTypes from 'prop-types';
import Chip from "@material-ui/core/Chip";
import {Icon,withStyles} from "@material-ui/core";


const CustomChip = withStyles({
    root: {
        background: "var(--color-blue-100)",
        // borderRadius: "10px",
        fontFamily: "Metropolis",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "12px",
        lineHeight: "12px",
        color: "var(--color-gray-600)"
    }
})(Chip);

function CustomChip1(props) {
    return (
        <div>
            <CustomChip {...props} deleteIcon={<Icon fontSize="small">close</Icon>}/>
        </div>
    );
}

CustomChip1.propTypes = {};
CustomChip1.defaultProps = {};

export default CustomChip1;
